/**
 * Fixed event catalogue — mirrors templateKeys dispatched by the content workflow.
 */
export const NOTIFICATION_EVENTS = [
  { key: "content-submitted", label: "محتوى جديد بانتظار المراجعة" },
  { key: "content-approved", label: "تمت الموافقة على المحتوى" },
  { key: "content-rejected", label: "تم رفض المحتوى" },
] as const;

const EVENT_LABELS = Object.fromEntries(
  NOTIFICATION_EVENTS.map((event) => [event.key, event.label]),
) as Record<string, string>;

export function getNotificationEventLabel(templateKey: string): string {
  return EVENT_LABELS[templateKey] ?? templateKey;
}
